import React from "react";
import { useSelector } from "react-redux";

import Footer from "../../components/public/Footer/Footer";
import { useLocation } from "react-router-dom";

const MainContainer = (props) => {
  const { error } = useSelector((store) => store.loader);
  const { isEtmfLocked } = useSelector((store) => store.template);
  const location = useLocation();

  return (
    <>
      <div
        className={
          props.showSidebar || location.pathname === "/oq"
            ? error.errorTxt || isEtmfLocked
              ? "main-container error-active-container"
              : "main-container"
            : error.errorTxt || isEtmfLocked
            ? "main-container error-full-main-container"
            : "main-container full-main-container"
        }
      >
        <div className="scroll-container">
          <section className="body-container">{props.children}</section>
          {location.pathname !== "/oq" && <Footer />}
        </div>
      </div>
    </>
  );
};

export default MainContainer;
